import { visitorPayload } from '../../interfaces/apiInterfaces';
import { AxiosResponseType } from '../../types/axiosTypes';
import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

async function getIdToken(): Promise<string> {
  const { tokens } = await fetchAuthSession();

  const idToken = tokens?.idToken?.toString();

  if (!idToken) {
    throw new Error('NO SESSION');
  }

  return idToken;
}

export const addVisitor = async (payload: visitorPayload) => {
  try {
    const idToken = await getIdToken();

    const res = await api.post<AxiosResponseType>('/visitor/login', {
      token: idToken,
      payload,
    });

    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Final visitor checkout.
 *
 * Allowed:
 * - ON_SITE
 * - TEMP_OUT
 */
export const logoutVisitor = async (visitorId: string) => {
  try {
    const idToken = await getIdToken();

    const res = await api.post<AxiosResponseType>('/visitor/logout', {
      token: idToken,
      visitorId,
    });

    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Visitor temporarily leaves the property.
 *
 * ON_SITE -> VISITOR_TEMP_OUT
 */
export const temporaryLeaveVisitor = async (visitorId: string) => {
  try {
    const idToken = await getIdToken();

    const res = await api.post<AxiosResponseType>('/visitor/temporary-leave', {
      token: idToken,
      visitorId,
    });

    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

/**
 * Visitor returns after a temporary departure.
 *
 * TEMP_OUT -> VISITOR_TEMP_IN
 */
export const returnVisitor = async (visitorId: string) => {
  try {
    const idToken = await getIdToken();

    const res = await api.post<AxiosResponseType>('/visitor/return', {
      token: idToken,
      visitorId,
    });

    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const searchVisitors = async (payload: {
  query: string;
  field: 'first' | 'last' | 'plate' | 'company';
  siteId: string;
}): Promise<AxiosResponseType | null> => {
  const idToken = await getIdToken();

  const res = await api.post<AxiosResponseType>('/visitor/search', {
    token: idToken,
    payload,
  });

  return res.data;
};

export const getSiteVisitorsByDay = async (payload: any) => {
  try {
    const idToken = await getIdToken();

    const res = await api.post('/visitor/get_visitors_by_day', {
      payload,
      token: idToken,
    });

    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getSiteVisitors = async (siteId: string) => {
  try {
    const idToken = await getIdToken();

    const res = await api.post('/visitor/get_site_visitors', {
      siteId,
      token: idToken,
    });

    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
